import React from 'react';
import { BrowserRouter as Router, Route, Redirect, Switch } from 'react-router-dom';
import { history } from "../history";

import "react-perfect-scrollbar/dist/css/styles.css"
import "prismjs/themes/prism-tomorrow.css"
import HorizontalLayout from "../components/layouts/HorizontalLayout"
import VerticalLayout from "../components/layouts/VerticalLayout"
import FullPageLayout from "../components/layouts/FullpageLayout"
import DynamicLayout from "../components/layouts/DynamicLayout";

import DashboardPage from '../components/dashboard/Dashboard';
import CustomerPage from '../components/customer/index';
import CustomerEdit from '../components/customer/edit';
import CustomerView from '../components/customer/view';
import CalendarApp from '../components/calendar/Calendar';
import LibraryApp from '../components/library';
import ActivityApp from '../components/activity';
import SettingsApp from '../components/settings';
import ProfileApp from '../components/profile';
import TodoApp from '../components/todo';
import TemplateBuilder from "../components/settings/pages/templateBuilder";

import SignUpPage from '../components/auth/SignUp';
import SignInPage from '../components/auth/SignIn';
import PasswordForgetPage from '../components/auth/PasswordForget';
import AccountPage from '../components/auth/Account';
import AdminPage from '../components/auth/Admin';
import PresenterMeetingRoomNew from '../components/meeting/PresenterMeetingRoomNew';
import PublicMeetingRoom from '../components/meeting/PublicMeetingRoom';
import ContentViewer from "../components/contentViewer";
import { IntlProviderWrapper } from "../utility/context/Internationalization"
import * as ROUTES from '../constants/routes';
import { withAuthentication } from '../components/auth/Session';
import { ToastContainer } from "react-toastify"
import AppOverlay from "./components/AppOverlay"
import "react-toastify/dist/ReactToastify.css"
import "../assets/scss/plugins/extensions/toastr.scss"
import { Spinner } from "reactstrap";
import { withFirebase } from "../services/Firebase";
import { inject, observer } from 'mobx-react';

const AuthenticatedApp = () => {
return <Router>
  <IntlProviderWrapper>
    <DynamicLayout >
      <Switch>
        <Route exact path={ROUTES.DASHBOARD} component={DashboardPage} />
        <Route exact path={ROUTES.MEETING} component={PresenterMeetingRoomNew} />
        <Route exact path={ROUTES.TEMPLATE_BUILDER} component={TemplateBuilder} />

        <Route exact path={ROUTES.CUSTOMER} component={CustomerPage} />
        <Route exact path={ROUTES.CUSTOMER_CREATE} component={CustomerEdit} />
        <Route exact path={ROUTES.CUSTOMER_EDIT} component={CustomerEdit} />
        <Route exact path={ROUTES.CUSTOMER_VIEW} component={CustomerView} />

        <Route exact path={ROUTES.CALENDAR} component={CalendarApp} />
        <Route exact path={ROUTES.LIBRARY} component={LibraryApp} />
        <Route exact path={ROUTES.ACTIVITY} component={ActivityApp} />
        <Route exact path={ROUTES.SETTINGS} component={SettingsApp} />
        <Route exact path={ROUTES.PROFILE} component={ProfileApp} />
        <Route exact path={ROUTES.TODO} component={TodoApp} />
        

        <Route path={ROUTES.ACCOUNT} component={AccountPage} />
        <Route path={ROUTES.ADMIN} component={AdminPage} />
        <Redirect from="/" to={ROUTES.DASHBOARD} />
      </Switch>
    </DynamicLayout>
  </IntlProviderWrapper>
</Router>
};

const UnAuthenticatedApp = () =>
  <Router>
    <Switch>
      <Route exact path={ROUTES.PUBLIC_MEETING} component={PublicMeetingRoom} />
      <Route exact path={ROUTES.PUBLIC_CONTENT_VIEWER} component={ContentViewer} />
      <Route path={ROUTES.SIGN_IN} component={SignInPage} />
      <Route path={ROUTES.SIGN_UP} component={SignUpPage} />
      <Route path={ROUTES.PASSWORD_FORGET} component={PasswordForgetPage} />
      <Redirect from="/" to={ROUTES.SIGN_IN} />
    </Switch>
  </Router>

@withAuthentication
@withFirebase
@inject('sessionStore', 'userControlStore', 'presenterControlStore', 
  'presenterMeetingStore', 'publicMeetingStore')
@observer
class App extends React.Component {

  handleWindowClose = () => {
    const {sessionStore, firebase} = this.props;
    if(sessionStore.authUser){
      //Disconnect any meeting for public user
      const {presenterMeetingStore, presenterControlStore} = this.props;
      const {meeting} = presenterMeetingStore;
      if(meeting){
        presenterControlStore.onWindowClose(firebase, authUser, meeting);
      }
    } else {
      //disconnect any meeting for logged in user
      const {publicMeetingStore, userControlStore} = this.props;
      const {meeting} = publicMeetingStore;
      if(meeting){
        userControlStore.onWindowClose(firebase, meeting);
      }
    }
  }

  componentWillUnmount() {
      window.removeEventListener('onbeforeunload', this.handleWindowClose);
  }

  componentDidMount(){
    const { firebase, sessionStore } = this.props;

    firebase.connectedRef().on("value", function(snap) {
      if (snap.val() === true) {
        sessionStore.hideOverlay();
      } else {
        if(sessionStore.disconnectedCount > 0){
          const loadingComp = <Spinner />;
          const isBlocking = false;
          sessionStore.showOverlay('Lost Connection to Meeting. Attempting to reconnect...', loadingComp, isBlocking);
        }
        sessionStore.disconnectedCount++;
      }
    });

    window.addEventListener('onbeforeunload', (ev) => {
      ev.preventDefault();
      //this.handleWindowClose()
      ev.returnValue = "window will close now";
    });
  }

  render() {
    const { sessionStore } = this.props
    return (
      <React.Fragment>
        <AppOverlay />
        <ToastContainer autoClose={1000} />
        {sessionStore.authUser ? (
          <AuthenticatedApp />
            ) : <UnAuthenticatedApp />}
        <div id="local_stream" />
        <div id="remote_stream" />
      </React.Fragment>
    )
  }
}

export default App;

